<template>
  <div class="share-base">
    <!-- <vue-qr :logoSrc="logoSrc" text="asdnasjnajsnasjkndasjda" ></vue-qr> -->
    <a-row v-if="!isOnlyQr">
      <a-col span="8">
        <vue-qr :logoSrc="logoSrc" :text="qrSrc" :size="200"></vue-qr>
      </a-col>
      <a-col span="16">
        <a-row>
          <a-col>
            <div class="title">{{$t('tour.share.address')}}：</div>
            <a-input v-model="qrSrc" />
          </a-col>
        </a-row>
        <a-row v-if="shareType == 'tour' && checkHbhousing">
          <a-col>
            <div class="title">{{$t('tour.share.circulationAddress')}}：</div>
            <a-input v-model="circulationSrc" />
          </a-col>
        </a-row>
        <a-row>
          <a-col>
            <div class="title">{{$t('tour.share.importHtml')}}：</div>
            <a-input v-model="ifrmeStr" />
          </a-col>
        </a-row>
        <a-row>
          <a-col>
            <p class="desc">{{desc}}</p>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
    <a-row v-else>
      <a-col span="24">
        <div class="e-code-box">
          <vue-qr :logoSrc="logoSrc" :text="qrSrc" :size="codeWidth"></vue-qr>
          <div class="texts">
            {{$t('tour.share.pcdescription1')}}<br/>
            {{$t('tour.share.pcdescription2')}}
          </div>
          <div class="wap-texts">
            {{$t('tour.share.pcdescription1')}}<br/>
            {{$t('tour.share.pcdescription2')}}
          </div>
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import path from "path";
import VueQr from "vue-qr";
import {checkHbhousing} from "@/api/user";

export default {
  components: { VueQr },
  props: {
    logoSrc: {
      default: "",
      type: String,
    },
    isOnlyQr: {
      default: false,
      type: Boolean,
    },
    workId: {
      type: String,
      // type:Number,
      required: true,
    },
    shareType: {
      type: String,
      default: "tour",
    },
  },
  data() {
    return {
      qrSrc: "",
      circulationSrc: "",
      baseUrl: window.location.href,
      desc: `${this.$t('tour.share.importDescription')}：
              <meta
                name="viewport"
                content="width=device-width, user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0"
              />`,
      ifrmeStr: "",
      codeWidth:300,
      checkHbhousing: false
    };
  },
  created() {
    this.handleParams();
    let width = `${document.documentElement.clientWidth}`
    let w = parseInt(width)
    if(w<768){
      this.codeWidth = parseInt(w)* 0.6
    }
    console.log('寬度',this.codeWidth)
    checkHbhousing().then((res) => {
      this.checkHbhousing = res.data;
    });
  },
  methods: {
    handleParams() {
      let fullPath = window.location.href;
      let pathArr = fullPath.split("/");
      let tourPathArr = [
        pathArr[0],
        pathArr[1],
        pathArr[2],
        this.shareType + "/" + this.workId,
      ];
      let tourCirculationPathArr = [
        pathArr[0],
        pathArr[1],
        pathArr[2],
        "tourCirculation/" + this.workId,
      ];
      this.qrSrc = tourPathArr.join("/");
      this.circulationSrc = tourCirculationPathArr.join("/");
      this.ifrmeStr = `<iframe src="${this.qrSrc}" frameborder="no" width="700" height="500" ></iframe>`;
    },
  },
};
</script>

<style lang="less" scoped>
.share-base {
  padding: 10px 20px;
  .title {
    margin-top: 10px;
  }
  .desc {
    margin-top: 10px;
  }
  .e-code-box{
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    .texts,.wap-texts{
      width: 100%;
      text-align: center;
      margin: 10px 0;
      font-size: 18px;
      color: #999;
    }
    .wap-texts{
      display: none;
    }
  }
}
  @media (max-width: 767px) {
    .share-base {
      .e-code-box{
        .texts{
          display: none;
        }
        .wap-texts{
          font-size: 14px;
          display: block;
        }
      }
    }
  }
</style>
